export function toPersianNumber (value) {
  return value.toString().replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d]);
}